var _circle, _rect, _rect2, _path, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgKio(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 210,
    height: 210,
    viewBox: "0 0 210 210",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 105,
    cy: 105,
    r: 105,
    fill: "#EAEAEA"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 109.695,
    y: 56.0043,
    width: 3.00086,
    height: 15.0043,
    transform: "rotate(180 109.695 56.0043)",
    fill: "#777777"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 110.07,
    y: 62.7563,
    width: 3.75108,
    height: 3.75108,
    transform: "rotate(180 110.07 62.7563)",
    fill: "#777777"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M77.4381 142.597L77.4381 76.7987L131.26 76.7987L131.26 145.571L88.6937 145.571",
    stroke: "#777777",
    strokeWidth: 5
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 105.219,
    y: 156.165,
    width: 29.1306,
    height: 5.36616,
    fill: "#777777"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 74.5547,
    y: 156.165,
    width: 27.5974,
    height: 5.36616,
    fill: "#777777"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 88.7344,
    y: 157.332,
    width: 13.4161,
    height: 5.31525,
    transform: "rotate(-90 88.7344 157.332)",
    fill: "#777777"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 114.576,
    y: 157.332,
    width: 13.4161,
    height: 5.31525,
    transform: "rotate(-90 114.576 157.332)",
    fill: "#777777"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 74.0957,
    y: 129.787,
    width: 5.31525,
    height: 19.6886,
    transform: "rotate(-125.616 74.0957 129.787)",
    fill: "#777777"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    width: 5.31525,
    height: 19.6886,
    transform: "matrix(0.582357 -0.812933 -0.812933 -0.582357 135.006 129.787)",
    fill: "#777777"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 101.062,
    y: 111.762,
    width: 6.73232,
    height: 10.5653,
    fill: "#777777",
    stroke: "#777777",
    strokeWidth: 4
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 91.3984,
    y: 100.204,
    width: 6.64406,
    height: 6.64406,
    fill: "#777777"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 111.33,
    y: 100.204,
    width: 6.64406,
    height: 6.64406,
    fill: "#777777"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKio);
export default __webpack_public_path__ + "static/media/kio.46fa76bd72fe3848b108a3c65cbe2c63.svg";
export { ForwardRef as ReactComponent };